module.exports = __webpack_public_path__ + "13188aa610952cfbd7ebc02817b9e0a0.png";